/* Flossei v3 - scroll reveal + hero video guard + hero cycling headline */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(){
    var els = document.querySelectorAll('.fv-rv:not(.is-in)');
    if(!els.length) return;
    if(reduce || !('IntersectionObserver' in window)){
      for(var i=0;i<els.length;i++){ els[i].classList.add('is-in'); }
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for(var j=0;j<els.length;j++){ io.observe(els[j]); }
    // safety: anything still hidden after 2.5s gets shown
    setTimeout(function(){
      var left = document.querySelectorAll('.fv-rv:not(.is-in)');
      for(var k=0;k<left.length;k++){
        var r = left[k].getBoundingClientRect();
        if(r.top < window.innerHeight) left[k].classList.add('is-in');
      }
    }, 2500);
  }

  function video(){
    var v = document.querySelector('.fv-hero__video');
    if(!v) return;
    v.muted = true; v.playsInline = true;
    if(reduce){ try{ v.pause(); }catch(e){} return; }
    var p = v.play();
    if(p && p.catch){ p.catch(function(){}); }
    // pause when off screen to save battery
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        en.forEach(function(e){
          if(e.isIntersecting){ var q=v.play(); if(q&&q.catch){q.catch(function(){});} }
          else { try{ v.pause(); }catch(err){} }
        });
      }, { threshold: 0.15 }).observe(v);
    }
  }

  function heroCycle(){
    var wrap = document.querySelector('.fv-hero__cycle');
    if(!wrap) return;
    var words = wrap.querySelectorAll('.fv-hero__cycle-word');
    if(words.length < 2 || reduce) return;
    var i = 0;
    setInterval(function(){
      words[i].classList.remove('is-active');
      i = (i + 1) % words.length;
      words[i].classList.add('is-active');
    }, 2200);
  }

  function boot(){ reveal(); video(); heroCycle(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();
